import React from 'react';
import { useDemoContext } from '../contexts/DemoContext';
import { useLocation } from 'react-router-dom';
import { Grid, Cell } from 'react-foundation';
import { IoInformationCircle } from 'react-icons/io5';
import '../stylesheets/components/DemoBanner.css';

const DemoBanner = () => {
  const { isDemoMode, endDemo } = useDemoContext();
  const location = useLocation();

  const getDemoContextMessage = () => {
    const path = location.pathname;
    
    if (path.includes('/conversations/new')) {
      return 'Creating a demo conversation';
    } else if (path.includes('/conversations/') && path.includes('/show')) {
      return 'Viewing demo conversation details';
    } else if (path.includes('/conversations/') && path.includes('/categories/edit')) {
      return 'Demo: Self-guided topic selection - Choose your conversation topics';
    } else if (path.includes('/conversations')) {
      return 'Browsing demo conversations';
    } else if (path.includes('/questionnaire')) {
      return 'Demo: Team member questionnaire - Complete wellbeing assessment';
    } else if (path.includes('/categories/results')) {
      return 'Demo: Review and edit your priority topics for discussion';
    } else if (path.includes('/categories')) {
      return 'Selecting demo conversation topics';
    } else if (path.includes('/team-member-prep-results')) {
      return 'Demo: Team member preparation complete - Ready for conversation';
    } else if (path.includes('/confirmation')) {
      return 'Demo: Review and confirm your preparation details';
    } else if (path.includes('/completed')) {
      return 'Demo conversation completed';
    } else if (path.includes('/canvas')) {
      return 'Using demo conversation canvas';
    } else if (path.includes('/demo')) {
      return 'Exploring demo features';
    } else {
      return 'Demo mode active';
    }
  };

  if (!isDemoMode) return null;

  return (
    <div className="demo-banner">
      <Grid className="demo-banner__content">
        <Cell small={12} large={10}>
          <div className="demo-banner__info">
            <IoInformationCircle className="demo-banner__icon" />
            <div className="demo-banner__text">
              <strong>Demo Mode Active</strong>
              <span>You're viewing a demonstration. No real data will be created or modified.</span>
              <span className="demo-banner__progress">
                {getDemoContextMessage()}
              </span>
            </div>
          </div>
        </Cell>
        <Cell small={12} large={2}>
          <button
            className="page-content__button--medium demo-banner__exit-button"
            onClick={endDemo}
            aria-label="Exit Demo Mode"
          >
            Exit Demo
          </button>
        </Cell>
      </Grid>
    </div>
  );
};

export default DemoBanner;
